var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 5.49996C3.66667 4.35069 4.12321 3.24849 4.93587 2.43583C5.74853 1.62317 6.85073 1.16663 8 1.16663C9.14927 1.16663 10.2515 1.62317 11.0641 2.43583C11.8768 3.24849 12.3333 4.35069 12.3333 5.49996V6.49996H14V15.8333H2V6.49996H3.66667V5.49996ZM5 6.49996H11V5.49996C11 4.70431 10.6839 3.94125 10.1213 3.37864C9.55871 2.81603 8.79565 2.49996 8 2.49996C7.20435 2.49996 6.44129 2.81603 5.87868 3.37864C5.31607 3.94125 5 4.70431 5 5.49996V6.49996ZM3.33333 7.83329V14.5H12.6667V7.83329H3.33333ZM4.66667 8.83596H6.00267V10.5H4.66667V8.83596ZM4.66667 11.5H6.00267V13.1693H4.66667V11.5Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.20acfa7b4acf95e1bfc04e90bffffb93.svg";
export { ForwardRef as ReactComponent };